import React from "react";
import { graphql } from "gatsby";
import Layout from "../../components/layout/layout";

import Helmet from "react-helmet";

import PageContainer from "../../components/layout/page-container";
import PageSection from "../../components/layout/page-section";
import ImageGrid from "../../components/images/grid";

class ImagesForYearPage extends React.Component {
  constructor({ data, pageContext }) {
    super();

    this.state = { data: data, pageContext: pageContext };
  }

  render() {
    const images = (this.state.data.allImagesJson) ?
                    this.state.data.allImagesJson.edges : null;
    const narratives = (this.state.data.allNarrativesJson) ?
                        this.state.data.allNarrativesJson.edges : null;
    const artists = (this.state.data.allArtistsJson) ?
                     this.state.data.allArtistsJson.edges : null;
    const venues = (this.state.data.allVenuesJson) ?
                    this.state.data.allVenuesJson.edges : null;
    const exhibits = (this.state.data.allExhibitsJson) ?
                    this.state.data.allExhibitsJson.edges : null;
    
    return (
      <Layout>
        <PageContainer
          bottomPadding="lg"
        >
          <Helmet>
            <title>{`Images from ${this.state.pageContext.slug}`}</title>
          </Helmet>
          <PageSection background="dark-accent">
            <h1 className="page-title">Images from {this.state.pageContext.slug}</h1>
          </PageSection>
          <PageSection topPadding="md">
            <ImageGrid images={images} 
                      narratives={narratives}
                      artists={artists}
                      venues={venues}
                      exhibits={exhibits} />
          </PageSection>
        </PageContainer>
      </Layout>
    )
  }
}

export default ImagesForYearPage;

export const query = graphql`
  query ImagesForYearQuery($year: Int!) {
    allImagesJson(filter: {year: {eq: $year}}) {
      edges {
        node {
          reference
          fullPath
          thumbPath
          alt
          caption
          credit
          narratives
          artists
          venues
          year
        }
      }
    },
    allExhibitsJson {
      edges {
        node {
          reference
          long_title
        }
      }
    }
    allNarrativesJson {
      edges {
        node {
          reference
          title
          exhibit
        }
      }
    },
    allArtistsJson {
      edges {
        node {
          reference
          canonical_name
        }
      }
    },
    allVenuesJson {
      edges {
        node {
          reference
          canonical_name
        }
      }
    }
  }
`;